import { RegistrationCommonInputProps } from 'features/registration/interface/registration';
import { EMAIL_DOMAINS } from 'features/registration/utility/utility';
import { FC } from 'react';
import FormRow from 'shared/components/form/formRow';
import InputText from 'shared/components/form/inputText';
import useInputFocus from 'shared/hooks/useInputFocus';

const RegistrationStep3: FC<RegistrationCommonInputProps> = ({ isFieldValueValid, errors, touched, setFieldValue, values, handleBlur, t }) => {
	const inputRef = useInputFocus();
	// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	const emailDomain = values.email.split('@')[1]!;
	const isWarning = !EMAIL_DOMAINS.includes(emailDomain) && values.email !== '';

	return (
		<FormRow flex={false}>
			<InputText
				label={t('email')}
				name="email"
				autoFocus
				inputRef={inputRef}
				isFieldValueValid={isFieldValueValid}
				errors={errors}
				touched={touched}
				onBlur={handleBlur}
				setFieldValue={setFieldValue}
				values={values}
				inputProps={{ inputMode: 'email' }}
				warnings={isWarning ? t('emailDomainWarning') : ''}
				cyTestRef="reg-email"
				cyErrorRef="reg-validation-error"
			/>
		</FormRow>
	);
};

export default RegistrationStep3;
